import React, { useState } from 'react';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import Button from '../../../../../components/Button';
import { asyncSimpleModal, reDirectPage, setDetailPageUrl } from '../../../../../lib/common';
import { PRODUCT_DETAIL_PAGE_TYPE, PRODUCT_STATUS } from '../../../../../constants/service/app/productConstants';
import { PRODUCT_EDIT_URL_PATH, PRODUCT_VERSION_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import './ProductBottomBar.scss';
import SubmitWithExternalChannelModal from '../../modal/SubmitWithExternalChannelModal';

const ProductBottomBar = (props) => {
  /**
   *  isRequest: 승인 요청 여부,
   *  isReject: 승인 거절 여부
   *  isDelete: 상품 삭제 여부
   *  isBanRequest: 상품 판매금지 재승인 요청 여부
   *  versionCnt: 상품 버전 개수 (버전 개수가 2개 이상일 때부터 버전 비교를 할 수 있습니다.)
   */

  /**
   *  **** pageType ****
   *  1. 상품 상세 (type : 0)
   *  2. 상품 등록 (type : 1)
   *  3. 상품 편집 (type : 2)
   *  4. 상품 복사 (type : 3)
   */
  const {
    form,
    pageType,
    productId,
    proStatusAndBrandInfo,
    openPreview,
    getRejectReasonList,
    permitProduct,
    permitBanProduct,
    rejectProduct,
    deleteProduct,
    onSubmit,
    shouldConfirmToSendExternalChannel,
  } = props;

  const { status, versionCnt, isRequest, isReject, isDelete, isBanRequest } = proStatusAndBrandInfo;

  const [permitModalVisible, setPermitModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);

  return (
    <FixedBottomNavBar className="product-bottom-bar">
      <div className="button-group">
        <div className="left">
          {/*미리보기*/}
          <Button type="button" color="light" text="미리보기" onClick={() => openPreview()} />

          {/*버전보기*/}
          {pageType !== PRODUCT_DETAIL_PAGE_TYPE.CREATE && versionCnt > 1 && (
            <Button
              type="button"
              color="gray"
              text="버전보기"
              onClick={() => reDirectPage({ path: setDetailPageUrl(PRODUCT_VERSION_URL_PATH, productId) })}
            />
          )}

          {/*거절 사유 보기*/}
          {isReject && (
            <Button type="button" color="gray" text="거절 사유" onClick={() => getRejectReasonList({ productId })} />
          )}

          {/*편집*/}
          {pageType === PRODUCT_DETAIL_PAGE_TYPE.DETAIL && !isDelete && (
            <Button
              type="button"
              color="primary"
              text="편집"
              onClick={() => reDirectPage({ path: setDetailPageUrl(PRODUCT_EDIT_URL_PATH, productId) })}
            />
          )}
        </div>

        <div className="right">
          {/*등록하기, 편집하기, 복사하기*/}
          {pageType !== PRODUCT_DETAIL_PAGE_TYPE.DETAIL && (
            <Button
              type="button"
              color="primary"
              text="저장"
              onClick={() => {
                if (pageType === PRODUCT_DETAIL_PAGE_TYPE.EDIT && shouldConfirmToSendExternalChannel()) {
                  setEditModalVisible(true);
                } else {
                  onSubmit();
                }
              }}
            />
          )}

          {/*승인하기*/}
          {pageType === PRODUCT_DETAIL_PAGE_TYPE.DETAIL && isRequest && !isBanRequest && (
            <Button
              type="button"
              color="primary"
              text="승인하기"
              onClick={async () => {
                if (shouldConfirmToSendExternalChannel()) {
                  setPermitModalVisible(true);
                } else {
                  const confirmResult = await asyncSimpleModal({
                    type: 'confirm',
                    title: '상품 승인',
                    message: '해당 상품을 승인하시겠습니까?',
                  });

                  if (confirmResult) {
                    permitProduct();
                  }
                }
              }}
            />
          )}

          {/*승인거절*/}
          {pageType === PRODUCT_DETAIL_PAGE_TYPE.DETAIL && isRequest && !isBanRequest && (
            <Button type="button" text="승인거절" onClick={() => rejectProduct('registration')} />
          )}

          {/*상품 판매 금지 승인하기*/}
          {pageType === PRODUCT_DETAIL_PAGE_TYPE.DETAIL && isBanRequest && (
            <Button type="button" color="primary" text="승인하기" onClick={permitBanProduct} />
          )}

          {/*상품 판매 금지 거절하기*/}
          {pageType === PRODUCT_DETAIL_PAGE_TYPE.DETAIL && isBanRequest && (
            <Button type="button" text="승인거절" onClick={() => rejectProduct('ban')} />
          )}

          {/*판매금지*/}
          {!isRequest &&
            !isReject &&
            !isDelete &&
            pageType !== (PRODUCT_DETAIL_PAGE_TYPE.CREATE || PRODUCT_DETAIL_PAGE_TYPE.COPY) &&
            status !== PRODUCT_STATUS.SALES_PROHIBIT && (
              <Button type="button" color="light" text="판매금지" onClick={() => rejectProduct('ban')} />
            )}

          {/*삭제하기*/}
          {pageType !== (PRODUCT_DETAIL_PAGE_TYPE.CREATE || PRODUCT_DETAIL_PAGE_TYPE.COPY) && !isDelete && (
            <Button type="button" color="gray" text="삭제" onClick={deleteProduct} />
          )}
        </div>
      </div>

      {permitModalVisible && (
        <SubmitWithExternalChannelModal
          title="상품 승인"
          description="해당 상품을 승인하시겠습니까?"
          form={form}
          isOpen={permitModalVisible}
          onOk={permitProduct}
          onCancel={() => setPermitModalVisible(false)}
        />
      )}

      {editModalVisible && (
        <SubmitWithExternalChannelModal
          title="상품 편집"
          description="해당 상품을 편집하시겠습니까?"
          form={form}
          isOpen={editModalVisible}
          onOk={onSubmit}
          onCancel={() => setEditModalVisible(false)}
        />
      )}
    </FixedBottomNavBar>
  );
};

export default ProductBottomBar;
